import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminLorAdjustments,
  initializeRateAdminLorAdjustmentsScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminLorAdjustments,
  saveLorAdjustmentsTableState
} from "../../../redux/actions/RateAdmin/rateadminLorAdjustments";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";

import RateAdminLorAdjustments from '../../../component/RateAdmin/RateAdminLorAdjustments';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function RateAdminLorAdjustmentsScreen(props) {
  const {
    fetchRateAdminLorAdjustments,
    initRateAdminLorAdjustmentsScreen,
    showPageLevelLoader,
    rateAdminLorAdjustmentsListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminLorAdjustments,
    isRateAdminLorAdjustmentsExportError,
    isRateAdminLorAdjustmentsExportSuccess,
    isLoading,
    savedTableState,
    saveLorAdjustmentsTableState,
  } = props;
  const navigate = useNavigate();
  
  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initRateAdminLorAdjustmentsScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminLorAdjustments(savedParams);
    } else {
      fetchRateAdminLorAdjustments({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchRateAdminLorAdjustments(props);
  };

  const handleTableStateChange = (tableState) => {
    saveLorAdjustmentsTableState(tableState);
  };

  const handleCreateRateAdminLorAdjustments = () => {
    navigate(APP_URLS.RATEADMIN_LOR_ADJUSTMENTS.CREATE);
  }
  const editRateAdminLorAdjustmentsRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_LOR_ADJUSTMENTS.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminLorAdjustments = {
    handleCreateRateAdminLorAdjustments,
    exportRateAdminLorAdjustments,
    isRateAdminLorAdjustmentsExportError,
    isRateAdminLorAdjustmentsExportSuccess,
    editRateAdminLorAdjustmentsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchRateAdminLorAdjustmentss: loadLazyData,
    tableData: {
      columns: rateAdminLorAdjustmentsListview?.columns,
      rows: rateAdminLorAdjustmentsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminLorAdjustments
        {...rateAdminLorAdjustments}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminLorAdjustmentsScreen: () => dispatch(initializeRateAdminLorAdjustmentsScreen()),
    fetchRateAdminLorAdjustments: (payload) => dispatch(fetchRateAdminLorAdjustments(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminLorAdjustments: (payload) => dispatch(exportRateAdminLorAdjustments(payload)),
    saveLorAdjustmentsTableState: (payload) => dispatch(saveLorAdjustmentsTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminLorAdjustmentsCreateSuccess: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "isRateAdminLorAdjustmentsCreateSuccess"
    ),
    rateAdminLorAdjustmentsListview: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "rateAdminLorAdjustmentsListview"
    ),
    showPageLevelLoader: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminLorAdjustmentsExportError: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "isRateAdminLorAdjustmentsExportError"
    ),
    isRateAdminLorAdjustmentsExportSuccess: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "isRateAdminLorAdjustmentsExportSuccess"
    ),
    savedTableState: selectFromRateAdminLorAdjustmentsReducer(
      state,
      "savedTableState"
    ),

    ...ownProps,
  };
};

const selectFromRateAdminLorAdjustmentsReducer = (state, path) => {
  return selectRateAdminLorAdjustmentsReducer(state)[path];
};

const selectRateAdminLorAdjustmentsReducer = ({ rateadminLorAdjustmentsReducer }) => {
  return rateadminLorAdjustmentsReducer;
};



export default connect(mapStateToProps, mapDispatchToProps)(RateAdminLorAdjustmentsScreen);
